import { field } from '../types';
import { FormControl, Select, MenuItem, FormHelperText, InputLabel } from '@mui/material';
import { getErrorText } from '..';
import { CustomSelect, CustomTextField } from 'theme/elements/Inputs';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { useAppSelector } from 'hooks/redux.hooks';

type props = {
	valid: boolean;
	cField: field;
	initialValidation: any;
	handleChange: any;
};

export default function SelectBox(props: props) {
	const t = useAppSelector(selectTranslations);
	const { valid, cField, handleChange, initialValidation } = props;
	const { name, value, label, placeholder, options, required } = cField.props;
	return (
		<FormControl error={!valid} fullWidth sx={cField.styleObj}>
			<CustomSelect key={name}>
				<InputLabel id="country-label">
					{label}
					{required ? ' *' : ''}
				</InputLabel>
			</CustomSelect>
			<Select
				{...cField.props}
				error={!valid}
				label={label}
				name={name}
				value={value || ''}
				onChange={handleChange}
				placeholder={placeholder}
			>
				{options?.map((option, idx) => {
					let val = cField.valueProperty ? option[cField.valueProperty] : option.value;
					let lab = cField.labelProperty ? option[cField.labelProperty] : option.label;
					return (
						<MenuItem key={`select-option-${idx}`} value={val}>
							{lab}
						</MenuItem>
					);
				})}
			</Select>
			<FormHelperText error={!valid}>{t(getErrorText(initialValidation, name))}</FormHelperText>
		</FormControl>
	);
}
